module.exports = __webpack_public_path__ + "opticutIco.png?57571ca58136d59d8f80b39620f643ef";